import React, { Component } from 'react';
import { Navbar, Nav, NavItem, Glyphicon } from 'react-bootstrap/lib';
import { LinkContainer } from 'react-router-bootstrap'

class Mainmenu extends Component {

    render() {
        return (
            <Navbar fluid collapseOnSelect bsStyle="default" className="MainMenu">
                <Navbar.Header className="">
                    <Navbar.Brand className="visible-xs">
                        Menu
                    </Navbar.Brand>
                    <Navbar.Toggle>
                        <Glyphicon glyph="menu-hamburger" />
                    </Navbar.Toggle>
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav>
                        <LinkContainer exact to="/">
                            <NavItem eventKey={1}>
                                <Glyphicon glyph="home" /> <span className="visible-xs">Home</span>
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer exact to="/info/organisatie">
                            <NavItem eventKey={2}>
                                Organisatie
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer exact to="/info/toelatingseisen">
                            <NavItem eventKey={3}>
                                Toelatingseisen
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer exact to="/info/rcro">
                            <NavItem eventKey={4}>
                                RC/RO/RT worden
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer exact to="/info/beroepseed">
                            <NavItem eventKey={5}>
                                Gedragscode
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer exact to="/info/voor-constructeurs">
                            <NavItem eventKey={6}>
                                Constructeurs
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer exact to="/info/voor-opdrachtgevers">
                            <NavItem eventKey={7}>
                                Opdrachtgevers
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer exact to="/account/mijn-cr">
                            <NavItem eventKey={8}>
                                Mijn CR
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer exact to="/info/contact">
                            <NavItem eventKey={9}>
                                Contact
                            </NavItem>
                        </LinkContainer>

                    </Nav>
                </Navbar.Collapse>
            </Navbar>

        );
    }
}

export default Mainmenu;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/Mainmenu.js